import { LoadingSpinningIcon } from '@assets/icons/LoadingSpinningIcon';
import AnomalyAlertIcon from '@assets/icons/minor/AnomalyAlertIcon';
import { useTranslation } from 'react-i18next';

export function farmAnomalyDataInformation(
  farmId: string,
  anomalyData:
    | {
        [key: string]: { anomalies_quantity: number; anomalies_area: number };
      }
    | undefined,
  isLoading: boolean,
  longTranslationKey: string,
  area: number,
  t: ReturnType<typeof useTranslation>['t']
) {
  if (isLoading) {
    return {
      tooltip: <p className="min-w-40 max-w-60">{t('header.properties.anomaly_loading')}</p>,
      data: '--',
      icon: <LoadingSpinningIcon />,
    };
  }
  if (anomalyData) {
    const anomalyInfo = anomalyData[farmId];
    if (anomalyInfo) {
      return {
        tooltip: (
          <p className="min-w-40 max-w-60">
            {t('header.properties.anomaly_area', {
              area: Math.round(anomalyInfo.anomalies_area / area),
              unit: t(longTranslationKey),
            })}
          </p>
        ),
        data: anomalyInfo.anomalies_quantity.toString(),
        icon: <AnomalyAlertIcon fill="#0066FF" />,
      };
    }
  }
  return {
    tooltip: <p className="min-w-40 max-w-60">{t('header.properties.anomaly_empty')}</p>,
    data: <span className="text-gray-500">{`--`}</span>,
    icon: <AnomalyAlertIcon fill="#A3A9B9" />,
  };
}
